/**
 * @file SuperAdminLayout.tsx
 * @brief Layout shell for the Super Admin space (top mega menu + footer).
 *
 * @author DES
 * @date 26-05-2026
 */

import { AdminShellLayout } from "./components/AdminShellLayout";
import { superAdminNavConfig } from "./components/superAdminNavConfig";

export function SuperAdminLayout() {
  return <AdminShellLayout nav={superAdminNavConfig} />;
}
